import { createStyles, makeStyles } from '@material-ui/core/styles';
import { INFO_GREEN } from 'constants/colors';
export default makeStyles(theme => createStyles({
  registration: {
    width: 300
  },
  registrationRoot: {
    width: '100%'
  },
  registrationResult: {
    margin: theme.spacing(2, 0, 0, 0),
    width: '100%',
    display: 'flex',
    backgroundColor: INFO_GREEN
  },
  input: {
    display: 'flex',
    marginTop: theme.spacing(2),
    width: '100%',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  registrationInput: {
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      flexDirection: 'column'
    }
  },
  searchButton: {
    marginLeft: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1, 0),
      paddingBottom: 0
    }
  },
  formInput: {
    width: '100%',
    maxWidth: 300,
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  formInputBox: {
    [theme.breakpoints.up('sm')]: {
      width: 300
    }
  },
  classificationBox: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    padding: theme.spacing(1, 0)
  },
  vehicleInputTitle: {
    marginTop: theme.spacing(2)
  },
  infoBox: {
    display: 'flex',
    alignItems: 'center'
  },
  infoText: {
    marginLeft: theme.spacing(1)
  },
  vehicleDocumentationInfo: {
    maxWidth: 300
  },
  alreadyAttached: {
    width: '100%'
  }
}));